import { createSelector } from '@reduxjs/toolkit';
import { selfBlocksSelector } from './self';

const selectedSourceWithPrioritySelector = createSelector(selfBlocksSelector, (sourcesWithPriority) => sourcesWithPriority.selectedSourceWithPriority);

export default selectedSourceWithPrioritySelector;
